import { render, staticRenderFns } from "./MatchingCreationStatusBar.vue?vue&type=template&id=c034bfa4&scoped=true&"
import script from "./MatchingCreationStatusBar.vue?vue&type=script&lang=ts&"
export * from "./MatchingCreationStatusBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c034bfa4",
  null
  
)

export default component.exports